module.exports = __webpack_public_path__ + "img/KM.064832ff.png";